<template>
  <Head title="期間ごとのユーザー継続率" />

  <BreezeAuthenticatedLayout>
    <main class="container p-admin">
      <AdminNav />
      <div class="c-header">
        <Link :href="`/users/analytics`" class="c-header__back">
          <img src="/images/icons/icon-chevron-left.svg" alt="back">
        </Link>
        <h2 class="c-header--h2">{{ days }}日ごとのユーザー継続率</h2>
      </div>

      <div class="mt-24 scrollable">
        <form @submit.prevent="updateCohort">
          <label for="title">期間</label>
          <div class="mt-1 c-input_flex">
            <input type="date" v-model="form.start_date" onkeydown="return false" name="start_date" class="c-input quarter">
            <p>〜</p>
            <input type="date" v-model="form.end_date" onkeydown="return false" name="end_date" class="c-input quarter">
            <input type="text" v-model="form.days" name="days" class="c-input quarter" style="text-align: right;">日ごと
            <button type="submit" class="c-button quarter">更新する</button>
          </div>
        </form>

        <table class="p-admin_table">
          <thead>
            <tr>
              <th>登録した期間</th>
              <th>継続率</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border-bottom: solid 3px #ccc;">
              <td>全体の継続率</td>
              <td>
                <div class="p-admin_cohort">
                  <div
                    v-for="periodNumber in Object.keys(overallRetentionRates)"
                    class="p-admin_cohort_cell bg-alpha"
                    :style="{'--bg-alpha': getAlphaValue(overallRetentionRates[periodNumber])}"
                    >
                      {{ (overallRetentionRates[periodNumber] * 100).toFixed(2) }}％
                    </div>
                </div>
              </td>
            </tr>
            <tr v-for="(rate, periodNumber) in retentionRates" :key="periodNumber">
              <td class="nowrap">{{ adjustedDate(periodNumber).toLocaleDateString() }} 〜
              <br>{{ totalUsersByPeriod[periodNumber] }}ユーザー</td>
              <td>
                <div class="p-admin_cohort">
                  <div
                    v-for="val in rate"
                    class="p-admin_cohort_cell bg-alpha"
                    :style="{'--bg-alpha': getAlphaValue(val)}"
                    >
                      {{ (val * 100).toFixed(2) }}％
                    </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Side />
    </main>
  </BreezeAuthenticatedLayout>

</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import Side from '@/Shared/Side'
import AdminNav from '@/Shared/AdminNav'

export default {
  components: {
    BreezeAuthenticatedLayout,
    Head,
    Link,
    useForm,
    Side,
    AdminNav
  },
  // mounted() {
  //   console.log(this.overallRetentionRates);
  // },
  props: {
    retentionRates: Object,
    totalUsersByPeriod: Object,
    overallRetentionRates: Object,
    start_date: String,
    end_date: String,
    days: String,
  },
  setup(props) {
    const form = useForm({
      start_date: props.start_date,
      end_date: props.end_date,
      days: props.days,
    });
    function updateCohort() {
      form.submit('get', '/cohorts', {
        onSuccess: () => {
          // リクエストが成功した後の処理（オプション）
        },
      });
    }
    return {
      form,
      updateCohort,
    };
  },

  methods: {
    getAlphaValue(val) {
      val = val * 0.9 + 0.1;
      return val;
    },
    adjustedDate(periodNumber) {
      const startDate = new Date(this.start_date);
      startDate.setDate(startDate.getDate() + periodNumber * this.days);
      return startDate;
    },
  },
};
</script>

<style scoped>
  .bg-alpha {
    background-color: rgba(243, 117, 8, var(--bg-alpha));
  }
</style>